import React, { useState } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { ShieldCheckIcon, LockIcon, BellIcon } from 'lucide-react';
export function PortalSignup() {
  useDocumentMeta({
    title: 'Client Portal | VCA Capital Advisors',
    description: 'Sign in or create your VCA Capital Advisors client portal account to manage your account, upload documents, and receive secure account notifications.',
    path: '/portal'
  });
  const [smsConsent, setSmsConsent] = useState(false);
  return <div className="min-h-screen bg-black text-white font-sans selection:bg-white/20" data-id="element-553">
      <Navigation data-id="element-554" />

      <main className="pt-32 pb-24 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-555">
        <div className="mb-12 text-center" data-id="element-556">
          <h1 className="text-4xl md:text-5xl font-medium mb-4 tracking-tight" data-id="element-557">
            Client Portal
          </h1>
          <p className="text-zinc-400 max-w-xl mx-auto" data-id="element-558">
            Sign in or create your VCA Capital Advisors account to manage your
            account, upload documents, and receive secure account
            notifications.
          </p>
        </div>

        {/* Trust Bar */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-12" data-id="element-559">
          <div className="flex items-center gap-2 justify-center text-sm text-zinc-500" data-id="element-560">
            <ShieldCheckIcon className="w-4 h-4 text-white shrink-0" data-id="element-561" />
            <span data-id="element-562">Secure Account Access</span>
          </div>
          <div className="flex items-center gap-2 justify-center text-sm text-zinc-500" data-id="element-563">
            <LockIcon className="w-4 h-4 text-white shrink-0" data-id="element-564" />
            <span data-id="element-565">2FA Verification</span>
          </div>
          <div className="flex items-center gap-2 justify-center text-sm text-zinc-500" data-id="element-566">
            <BellIcon className="w-4 h-4 text-white shrink-0" data-id="element-567" />
            <span data-id="element-568">Account Notifications</span>
          </div>
        </div>

        {/* Existing Client Sign-In */}
        <div className="bg-zinc-900/50 border border-zinc-800 rounded-2xl p-8 mb-8" data-id="element-569">
          <h2 className="text-2xl font-medium text-white mb-6" data-id="element-570">
            Sign In to Your Account
          </h2>
          <div className="space-y-4" data-id="element-571">
            <div data-id="element-572">
              <label className="block text-sm font-medium text-zinc-400 mb-2" data-id="element-573">
                Email Address
              </label>
              <input type="email" className="w-full bg-black/40 border border-zinc-800 rounded-xl px-4 py-3 text-white placeholder-zinc-600 focus:outline-none focus:border-zinc-600" placeholder="you@business.com" data-id="element-574" />
            </div>
            <div data-id="element-575">
              <label className="block text-sm font-medium text-zinc-400 mb-2" data-id="element-576">
                Password
              </label>
              <input type="password" className="w-full bg-black/40 border border-zinc-800 rounded-xl px-4 py-3 text-white placeholder-zinc-600 focus:outline-none focus:border-zinc-600" placeholder="\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022" data-id="element-577" />
            </div>
            <button className="w-full bg-white text-black font-medium py-3 rounded-xl hover:bg-zinc-100 transition-colors" data-id="element-578">
              Sign In
            </button>
          </div>
        </div>

        {/* New Account Creation */}
        <div className="bg-zinc-900/50 border border-zinc-800 rounded-2xl p-8" data-id="element-579">
          <h2 className="text-2xl font-medium text-white mb-2" data-id="element-580">
            Create Your Account
          </h2>
          <p className="text-zinc-400 text-sm mb-6" data-id="element-581">
            New users: create a portal account to manage your documents and
            receive secure account notifications.
          </p>
          <div className="space-y-4" data-id="element-582">
            <div data-id="element-583">
              <label className="block text-sm font-medium text-zinc-400 mb-2" data-id="element-584">
                Full Name
              </label>
              <input type="text" className="w-full bg-black/40 border border-zinc-800 rounded-xl px-4 py-3 text-white placeholder-zinc-600 focus:outline-none focus:border-zinc-600" placeholder="John Smith" data-id="element-585" />
            </div>
            <div data-id="element-586">
              <label className="block text-sm font-medium text-zinc-400 mb-2" data-id="element-587">
                Business Email
              </label>
              <input type="email" className="w-full bg-black/40 border border-zinc-800 rounded-xl px-4 py-3 text-white placeholder-zinc-600 focus:outline-none focus:border-zinc-600" placeholder="you@business.com" data-id="element-588" />
            </div>
            <div data-id="element-589">
              <label className="block text-sm font-medium text-zinc-400 mb-2" data-id="element-590">
                Mobile Phone Number
              </label>
              <input type="tel" className="w-full bg-black/40 border border-zinc-800 rounded-xl px-4 py-3 text-white placeholder-zinc-600 focus:outline-none focus:border-zinc-600" placeholder="(555) 555-5555" data-id="element-591" />
            </div>
            <div data-id="element-592">
              <label className="block text-sm font-medium text-zinc-400 mb-2" data-id="element-593">
                Create Password
              </label>
              <input type="password" className="w-full bg-black/40 border border-zinc-800 rounded-xl px-4 py-3 text-white placeholder-zinc-600 focus:outline-none focus:border-zinc-600" placeholder="\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022" data-id="element-594" />
            </div>

            {/* SMS Consent */}
            <div className="bg-black/40 border border-zinc-800 rounded-xl p-4 mt-6" data-id="element-595">
              <label className="flex items-start gap-3 cursor-pointer" data-id="element-596">
                <input type="checkbox" checked={smsConsent} onChange={e => setSmsConsent(e.target.checked)} className="mt-1 w-4 h-4 rounded border-zinc-700 bg-black text-white focus:ring-zinc-600 shrink-0" data-id="element-597" />
                <span className="text-xs text-zinc-400 leading-relaxed" data-id="element-598">
                  By providing my mobile phone number and checking this box, I
                  consent to receive transactional SMS messages from VCA Capital
                  Advisors Inc. for account-related purposes only, including:
                  two-factor authentication codes, sign-in alerts, password
                  reset notifications, account and document status
                  notifications, document request notifications, and account
                  security alerts. Message frequency varies based on account
                  activity. Msg &amp; data rates may apply. Reply STOP to opt
                  out, HELP for help. SMS consent is not required to use our
                  services. See our{' '}
                  <a href="/privacy" className="text-white underline hover:text-zinc-300" data-id="element-599">
                    Privacy Policy
                  </a>{' '}
                  and{' '}
                  <a href="/terms" className="text-white underline hover:text-zinc-300" data-id="element-600">
                    Terms of Service
                  </a>
                  .
                </span>
              </label>
            </div>

            <button className="w-full bg-white text-black font-medium py-3 rounded-xl hover:bg-zinc-100 transition-colors mt-2" data-id="element-601">
              Create Account
            </button>
          </div>
        </div>
      </main>

      <Footer data-id="element-602" />
    </div>;
}